import { OrderedMap } from "immutable";
export const isPreviewEnabled = (config) => !!config && typeof config.threshold === "number" && config.threshold > 0;
const restrictField = (scoped, field, scope) => {
  if (scope.length === 0) return scoped;
  const userValues = scoped.filters.get(field);
  const values = userValues ? userValues.filter((value) => scope.includes(value)) : scope;
  return values.length > 0 ? { ...scoped, filters: scoped.filters.set(field, values) } : { filters: scoped.filters.set(field, scope), matchesNothing: true };
};
export const scopeFiltersToEvent = (filters, assetType, config) => {
  var _a, _b;
  const typeScoped = {
    filters: (filters != null ? filters : OrderedMap()).set("type", [assetType]),
    matchesNothing: !isPreviewEnabled(config)
  };
  const categoryScoped = restrictField(typeScoped, "category", (_a = config == null ? void 0 : config.categories) != null ? _a : []);
  return restrictField(categoryScoped, "priority", ((_b = config == null ? void 0 : config.priorities) != null ? _b : []).map(String));
};
